{
  "admin-hub.ci-test.message-template-template-hello-world": [
    {
      "type": 0,
      "value": "Hello "
    },
    {
      "type": 1,
      "value": "propA"
    },
    {
      "type": 0,
      "value": ". Is is a lovely "
    },
    {
      "type": 1,
      "value": "propB"
    }
  ],
  "ci-generation.email.body": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "ci-generation.email.body.hello": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "ci-generation.email.body.img.alt": [
    {
      "type": 0,
      "value": "This is the alt text for the image"
    }
  ],
  "ci-generation.email.body.regards": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "ci-generation.email.body.signoff": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "ci-generation.email.subject": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "ci-generation.email.unsubscribe.text": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "post-office.test-message-digest-email-template.test-message.email.body.digest-title": [
    {
      "type": 0,
      "value": "You have "
    },
    {
      "type": 1,
      "value": "numberOfMsg"
    },
    {
      "type": 0,
      "value": " new messages!"
    }
  ],
  "post-office.test-message-digest-email-template.test-message.email.body.message-body": [
    {
      "type": 1,
      "value": "defaultMessage"
    }
  ],
  "post-office.test-message-digest-local-template.test-message.email.body.digest-title": [
    {
      "type": 0,
      "value": "You have "
    },
    {
      "type": 1,
      "value": "numberOfMsg"
    },
    {
      "type": 0,
      "value": " new messages!"
    }
  ],
  "post-office.test-message-digest-local-template.test-message.email.body.message-body": [
    {
      "type": 1,
      "value": "defaultMessage"
    }
  ],
  "post-office.test-message-microsoft-teams.sample-hello-message": [
    {
      "type": 0,
      "value": "Hello, this is test message from Post Office: "
    },
    {
      "type": 1,
      "value": "text"
    }
  ],
  "post-office.test-message.email.subject": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.test-messages.test-message-config-sets.sample-hello-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, *This is notification test from post office*"
    }
  ],
  "post-office.test-messages.test-message-digest-slack-v2.heading.no-translate": [
    {
      "type": 0,
      "value": "Post Office Slack digest v2 delivered "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " messages"
    }
  ],
  "post-office.test-messages.test-message-digest-slack-v2.item.no-translate": [
    {
      "type": 0,
      "value": "V2 item: "
    },
    {
      "type": 1,
      "value": "message"
    }
  ],
  "post-office.test-messages.test-message-lifecycle-email-recipients.sample-hello-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, *This is notification test from post office*"
    }
  ],
  "post-office.test-messages.test-message-lifecycle.sample-hello-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, *This is notification test from post office*"
    }
  ],
  "post-office.test-messages.test-message-load-test-push-flow-email-mobile-push.sample-mobile-notification-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a mobile push notification test from post office."
    }
  ],
  "post-office.test-messages.test-message-mobile-push-jira-ugc.redacted.sample-mobile-notification-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a redacted test mobile push notification from post office."
    }
  ],
  "post-office.test-messages.test-message-mobile-push-jira-ugc.sample-mobile-notification-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a mobile push notification test from post office."
    }
  ],
  "post-office.test-messages.test-message-mobile-push.greeting.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a mobile push notification test from post office."
    }
  ],
  "post-office.test-messages.test-message-mobile-push.redacted.greeting.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a redacted mobile push notification test from post office."
    }
  ],
  "post-office.test-messages.test-message-no-tracking.sample-hello-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, *This is notification test from post office*"
    }
  ],
  "post-office.test-messages.test-message-slack-experiment-exposure.sample-hello-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, *This is notification test from post office*"
    }
  ],
  "post-office.test-messages.test-message-transform-metadata.sample-hello-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, *This is notification test from post office*"
    }
  ],
  "post-office.test-messages.test-slack-notification-v2.sample-hello-message.no-translate": [
    {
      "type": 0,
      "value": "Post Office Slack digest v2 source: "
    },
    {
      "type": 1,
      "value": "message"
    }
  ],
  "post-office.test-slack-notification.sample-hello-message": [
    {
      "type": 0,
      "value": "Hello, *This is notification test from post office*"
    }
  ],
  "product-store-personal-use-case.hello-world": [
    {
      "type": 0,
      "value": "Hello. Is is a lovely"
    }
  ],
  "test-message.test-message-email-onboarding-test.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-message.test-message-email-onboarding-test.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-message.test-message-email-onboarding-test.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-message.test-message-email-onboarding-test.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is an test onboarding message for "
    },
    {
      "type": 1,
      "value": "team"
    },
    {
      "type": 0,
      "value": " team from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-message.test-message-email-onboarding-test.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-message.test-message-email-onboarding-test.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-message.test-message-email-onboarding-test.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.app-switcher-discovery-section.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "test-messages.app-switcher-discovery-section.test-content": [
    {
      "type": 0,
      "value": "This is a test message."
    }
  ],
  "test-messages.app-switcher-upgrade-section.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "test-messages.app-switcher-upgrade-section.test-content": [
    {
      "type": 0,
      "value": "This is a test message."
    }
  ],
  "test-messages.email.body.regards": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.in-app-example.hello-world": [
    {
      "type": 0,
      "value": "Hello "
    },
    {
      "type": 1,
      "value": "propA"
    },
    {
      "type": 0,
      "value": ". Is is a lovely "
    },
    {
      "type": 1,
      "value": "propB"
    }
  ],
  "test-messages.in-app-notification-comment-rollup.second-comment": [
    {
      "type": 1,
      "value": "actor"
    },
    {
      "type": 0,
      "value": " commented on a page"
    }
  ],
  "test-messages.in-app-notification-mention-rollup.first-comment": [
    {
      "type": 1,
      "value": "reactor"
    },
    {
      "type": 0,
      "value": " mentioned you in a comment"
    }
  ],
  "test-messages.in-app-notification-reaction-rollup.many-actors": [
    {
      "type": 1,
      "value": "actor1Name"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "otherActorsCount"
    },
    {
      "type": 0,
      "value": " others reacted to your page"
    }
  ],
  "test-messages.in-app-notification-reaction-rollup.one-actor": [
    {
      "type": 1,
      "value": "actor1Name"
    },
    {
      "type": 0,
      "value": " reacted to your page"
    }
  ],
  "test-messages.in-app-notification-reaction-rollup.two-actors": [
    {
      "type": 1,
      "value": "actor1Name"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "actor2Name"
    },
    {
      "type": 0,
      "value": " reacted to your page"
    }
  ],
  "test-messages.in-app-notification.email-onboarding.body": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ", This is an onboarding test message for "
    },
    {
      "type": 1,
      "value": "team"
    },
    {
      "type": 0,
      "value": " team."
    }
  ],
  "test-messages.in-app-notification.email-onboarding.title": [
    {
      "type": 0,
      "value": "Welcome!"
    }
  ],
  "test-messages.in-app-notification.title": [
    {
      "type": 0,
      "value": "Test Notification "
    },
    {
      "type": 1,
      "value": "title"
    }
  ],
  "test-messages.jira-navigation-topbar-edition-awareness.hello-world": [
    {
      "type": 0,
      "value": "Hello "
    },
    {
      "type": 1,
      "value": "propA"
    },
    {
      "type": 0,
      "value": ". Is is a lovely "
    },
    {
      "type": 1,
      "value": "propB"
    }
  ],
  "test-messages.post-office-gold-1.description.no-translate": [
    {
      "type": 0,
      "value": "Post Office Gold test message."
    }
  ],
  "test-messages.post-office-gold-1.title.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message"
    }
  ],
  "test-messages.redacted-email.body.regards": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.team-message-email-ugc.message-template.email.redacted.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Redacted Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-client-generation.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-client-generation.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-client-generation.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-client-generation.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-client-generation.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-client-generation.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-client-generation.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-config-sets.in-app.cs-0.flag.body.no-translate": [
    {
      "type": 0,
      "value": "This is the cs-0 test message body"
    }
  ],
  "test-messages.test-message-config-sets.in-app.cs-0.flag.title.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message (cs-0)"
    }
  ],
  "test-messages.test-message-config-sets.in-app.cs-0.learn-more.no-translate": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "test-messages.test-message-config-sets.in-app.flag.body.no-translate": [
    {
      "type": 0,
      "value": "This is the test message body"
    }
  ],
  "test-messages.test-message-config-sets.in-app.flag.title.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message"
    }
  ],
  "test-messages.test-message-config-sets.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-config-sets.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-config-sets.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-config-sets.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-config-sets.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-config-sets.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-config-sets.test-message.email.body.tracked-link.no-translate": [
    {
      "type": 0,
      "value": "Click here to visit Atlassian"
    }
  ],
  "test-messages.test-message-config-sets.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-content-diffing.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-content-diffing.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-content-diffing.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-content-diffing.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-content-diffing.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-content-diffing.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-content-diffing.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-delivery-control.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-delivery-control.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-delivery-control.message-template.in-app-notification.body.no-translate": [
    {
      "type": 1,
      "value": "body"
    }
  ],
  "test-messages.test-message-delivery-control.message-template.in-app-notification.title.no-translate": [
    {
      "type": 0,
      "value": "Template Notification "
    },
    {
      "type": 1,
      "value": "title"
    }
  ],
  "test-messages.test-message-delivery-control.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-delivery-control.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-delivery-control.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-delivery-control.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-delivery-control.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-digest-email.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-digest-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-digest-email.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hey "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-digest-email.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment. Here is your daily digest (rick) rollup for the "
    },
    {
      "type": 1,
      "value": "site"
    },
    {
      "type": 0,
      "value": " workspace"
    }
  ],
  "test-messages.test-message-digest-email.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-digest-email.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-digest-email.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-digest-local.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-digest-local.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-digest-local.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hey "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-digest-local.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment. Here is your daily digest (rick) rollup for the "
    },
    {
      "type": 1,
      "value": "site"
    },
    {
      "type": 0,
      "value": " workspace"
    }
  ],
  "test-messages.test-message-digest-local.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-digest-local.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-digest-local.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-email-cdn.message-template-template.email.body.img.alt": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-email-cdn.message-template.email.subject": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-email-cdn.test-message.email.body": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-email-cdn.test-message.email.body.hello": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-email-cdn.test-message.email.body.regards": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-email-cdn.test-message.email.body.signoff": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-email-cdn.test-message.email.unsubscribe.text": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-email-experiment-exposure.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-email-experiment-exposure.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-email-experiment-exposure.test-message.email.body.button.no-translate": [
    {
      "type": 0,
      "value": "Click me!"
    }
  ],
  "test-messages.test-message-email-experiment-exposure.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-email-experiment-exposure.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-email-experiment-exposure.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-email-experiment-exposure.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-email-experiment-exposure.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-email-high-priority.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-email-high-priority.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-email-high-priority.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-email-high-priority.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-email-high-priority.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-email-high-priority.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-email-high-priority.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-email-log-dropping.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-email-log-dropping.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-email-log-dropping.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-email-log-dropping.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-email-log-dropping.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-email-log-dropping.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-email-log-dropping.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-email-low-priority.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-email-low-priority.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-email-low-priority.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-email-low-priority.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-email-low-priority.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-email-low-priority.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-email-low-priority.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-email-mfc.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-email-mfc.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-email-ugc.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-email-ugc.message-template-template.email.redacted.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-email-ugc.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-email-ugc.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-email-ugc.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-email-ugc.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-email-ugc.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-email-ugc.test-message.email.redacted.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-email-ugc.test-message.email.redacted.body.no-translate": [
    {
      "type": 0,
      "value": "This is a redacted test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-email-ugc.test-message.email.redacted.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-email-ugc.test-message.email.redacted.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-email-ugc.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-grouped-recipients.message-template.email.subject": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-grouped-recipients.test-message.email.body": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-grouped-recipients.test-message.email.body.hello": [
    {
      "type": 0,
      "value": "Hello"
    }
  ],
  "test-messages.test-message-grouped-recipients.test-message.email.body.regards": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-grouped-recipients.test-message.email.body.signoff": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-in-app-notification-comment-rollup.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-in-app-notification-comment-rollup.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office test-message-in-app-notification-comment-rollup "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-in-app-notification-comment-rollup.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-in-app-notification-mention-rollup.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-in-app-notification-mention-rollup.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office test-message-in-app-notification-mention-rollup "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-in-app-notification-mention-rollup.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-in-app-notification-reaction-rollup.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-in-app-notification-reaction-rollup.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office test-message-in-app-notification-reaction-rollup "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-in-app-notification.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-in-app-notification.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office test-message-in-app-notification "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-in-app-notification.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-in-app-notification.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-in-app-notification.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-in-app-notification.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-in-app-notification.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-inapp-engagement.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-inapp-ep-modal.confirm.no-translate": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "test-messages.test-message-inapp-ep-modal.description.no-translate": [
    {
      "type": 0,
      "value": "We're also improving how we incorporate the terms you use to define work, so that Jira speaks your language — no matter what you're working on."
    }
  ],
  "test-messages.test-message-inapp-ep-modal.read-more.no-translate": [
    {
      "type": 0,
      "value": "Read more"
    }
  ],
  "test-messages.test-message-inapp-ep-modal.title.no-translate": [
    {
      "type": 0,
      "value": "'Work' is the new term for items tracked in Jira"
    }
  ],
  "test-messages.test-message-inapp-implicit-pendo.description.no-translate": [
    {
      "type": 0,
      "value": "Implicit Pendo test message."
    }
  ],
  "test-messages.test-message-inapp-implicit-pendo.title.no-translate": [
    {
      "type": 0,
      "value": "Conquering "
    },
    {
      "type": 1,
      "value": "planet"
    },
    {
      "type": 0,
      "value": " is "
    },
    {
      "type": 1,
      "value": "status"
    }
  ],
  "test-messages.test-message-inapp.description.no-translate": [
    {
      "type": 0,
      "value": "Post Office in-app test message."
    }
  ],
  "test-messages.test-message-inapp.title.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message"
    }
  ],
  "test-messages.test-message-lifecycle-email-recipients.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-lifecycle-email-recipients.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-lifecycle-email-recipients.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-lifecycle-email-recipients.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-lifecycle-email-recipients.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-lifecycle-email-recipients.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-lifecycle-email-recipients.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-lifecycle.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-lifecycle.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-lifecycle.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-lifecycle.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-lifecycle.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-lifecycle.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Kind Regards,"
    }
  ],
  "test-messages.test-message-lifecycle.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-link-tracking.email.heading.no-translate": [
    {
      "type": 0,
      "value": "Origin Tracing — Tracked Link Test ("
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "test-messages.test-message-link-tracking.email.intro.no-translate": [
    {
      "type": 0,
      "value": "This email tests Post Office tracked links. Tracked links go through the Post Office redirect service; plain links do not. Click each link and inspect the redirect URL to verify origin tracing."
    }
  ],
  "test-messages.test-message-link-tracking.email.tracked-link-atl-origin.no-translate": [
    {
      "type": 0,
      "value": "TrackedLink with atlOrigin param"
    }
  ],
  "test-messages.test-message-link-tracking.email.tracked-link-atlassian.no-translate": [
    {
      "type": 0,
      "value": "TrackedLink to https://atlassian.com"
    }
  ],
  "test-messages.test-message-link-tracking.email.tracked-link-external.no-translate": [
    {
      "type": 0,
      "value": "TrackedLink to https://www.example.com (non-Atlassian)"
    }
  ],
  "test-messages.test-message-link-tracking.email.tracked-link-pdf.no-translate": [
    {
      "type": 0,
      "value": "TrackedLink to PDF"
    }
  ],
  "test-messages.test-message-link-tracking.email.tracked-link-tenanted.no-translate": [
    {
      "type": 0,
      "value": "TrackedLink to https://hello.atlassian.net/wiki/home (tenanted)"
    }
  ],
  "test-messages.test-message-link-tracking.email.tracked-section.no-translate": [
    {
      "type": 0,
      "value": "Tracked links"
    }
  ],
  "test-messages.test-message-link-tracking.email.unsubscribe.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-link-tracking.email.untracked-link-atl-origin.no-translate": [
    {
      "type": 0,
      "value": "Plain link with atlOrigin param"
    }
  ],
  "test-messages.test-message-link-tracking.email.untracked-link-atlassian.no-translate": [
    {
      "type": 0,
      "value": "Plain link to https://atlassian.com"
    }
  ],
  "test-messages.test-message-link-tracking.email.untracked-link-external.no-translate": [
    {
      "type": 0,
      "value": "Plain link to https://www.example.com (non-Atlassian)"
    }
  ],
  "test-messages.test-message-link-tracking.email.untracked-link-pdf.no-translate": [
    {
      "type": 0,
      "value": "Plain link to PDF"
    }
  ],
  "test-messages.test-message-link-tracking.email.untracked-link-tenanted.no-translate": [
    {
      "type": 0,
      "value": "Plain link to https://hello.atlassian.net/wiki/home (tenanted)"
    }
  ],
  "test-messages.test-message-link-tracking.email.untracked-section.no-translate": [
    {
      "type": 0,
      "value": "Plain (untracked) links"
    }
  ],
  "test-messages.test-message-load-test-push-flow-email-mobile-push.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-load-test-push-flow-email-mobile-push.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-marketing.app-switcher-discovery-section.description.no-translate": [
    {
      "type": 0,
      "value": "Post Office app-switcher-discovery-section marketing test message."
    }
  ],
  "test-messages.test-message-marketing.app-switcher-discovery-section.title.no-translate": [
    {
      "type": 0,
      "value": "Jira Software"
    }
  ],
  "test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-marketing.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-marketing.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-marketing.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-marketing.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-marketing.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-message-failures.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-message-failures.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-message-failures.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-message-failures.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-message-failures.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-message-failures.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-message-failures.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-nd-ni-influents-mapper.influents.message-main.no-translate": [
    {
      "type": 0,
      "value": "Main line ("
    },
    {
      "type": 1,
      "value": "text"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "test-messages.test-message-nd-ni-influents-mapper.ingestion.action.no-translate": [
    {
      "type": 0,
      "value": "Open ("
    },
    {
      "type": 1,
      "value": "emoji"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "test-messages.test-message-nd-ni-influents-mapper.ingestion.entity.no-translate": [
    {
      "type": 0,
      "value": "Entity for "
    },
    {
      "type": 1,
      "value": "team"
    }
  ],
  "test-messages.test-message-nd-ni-influents-mapper.ingestion.path.no-translate": [
    {
      "type": 0,
      "value": "Path ("
    },
    {
      "type": 1,
      "value": "team"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "test-messages.test-message-nd-ni-influents-mapper.ingestion.title.no-translate": [
    {
      "type": 0,
      "value": "Team "
    },
    {
      "type": 1,
      "value": "teamName"
    },
    {
      "type": 0,
      "value": " update"
    }
  ],
  "test-messages.test-message-no-tracking.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-no-tracking.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-no-tracking.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-no-tracking.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-no-tracking.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-no-tracking.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-no-tracking.test-message.email.body.tracked-link.no-translate": [
    {
      "type": 0,
      "value": "This is a TrackedLink that isn't being tracked!"
    }
  ],
  "test-messages.test-message-no-tracking.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-notifications-platform.message-template.notification-drawer.message.no-translate": [
    {
      "type": 1,
      "value": "actorName"
    },
    {
      "type": 0,
      "value": " updated your page"
    }
  ],
  "test-messages.test-message-persona-email.message-template-template.email.body.img.alt": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-persona-email.message-template.email.subject": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-persona-email.test-message.email.body": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-persona-email.test-message.email.body.regards": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-persona-email.test-message.email.body.signoff": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-persona-email.test-message.email.unsubscribe.text": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-raw-recipients.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-raw-recipients.test-message.email.body.greeting.no-translate": [
    {
      "type": 1,
      "value": "greeting"
    }
  ],
  "test-messages.test-message-raw-recipients.test-message.email.body.hello.name.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi,"
    }
  ],
  "test-messages.test-message-raw-recipients.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-tap-ingestion-trigger-subscription.description.no-translate": [
    {
      "type": 0,
      "value": "TAP ingestion trigger subscription test message."
    }
  ],
  "test-messages.test-message-tap-ingestion-trigger-subscription.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-tap-ingestion-trigger-subscription.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message-tap-ingestion-trigger-subscription.title.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message"
    }
  ],
  "test-messages.test-message-transform-metadata.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "test-messages.test-message-transform-metadata.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "test-messages.test-message-transform-metadata.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "test-messages.test-message-transform-metadata.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "test-messages.test-message-transform-metadata.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "test-messages.test-message-transform-metadata.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message-transform-metadata.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message.app.img.alt.large": [
    {
      "type": 0,
      "value": "test image 2"
    }
  ],
  "test-messages.test-message.app.img.alt.plant": [
    {
      "type": 0,
      "value": "test image 1"
    }
  ],
  "test-messages.test-message.email.body": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment. "
    },
    {
      "type": 1,
      "value": "additionalBody"
    }
  ],
  "test-messages.test-message.email.body.hello": [
    {
      "type": 0,
      "value": "Hi Atlassian,"
    }
  ],
  "test-messages.test-message.email.body.img.alt": [
    {
      "type": 0,
      "value": "this is the alt for the test-message-email message template"
    }
  ],
  "test-messages.test-message.email.body.signoff": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message.email.unsubscribe.text": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "test-messages.test-message.redacted-email.body": [
    {
      "type": 0,
      "value": "This is the redacted version of the test email message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment. "
    },
    {
      "type": 1,
      "value": "additionalBody"
    }
  ],
  "test-messages.test-message.redacted-email.body.hello": [
    {
      "type": 0,
      "value": "Hi Atlassian,"
    }
  ],
  "test-messages.test-message.redacted-email.body.img.alt": [
    {
      "type": 0,
      "value": "this is the alt for the test-message-email message template"
    }
  ],
  "test-messages.test-message.redacted-email.body.signoff": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "test-messages.test-message.redacted-email.unsubscribe.text": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "wac-global-nav-product-recommendation.hello-world": [
    {
      "type": 0,
      "value": "Hello. Is is a lovely"
    }
  ]
}